import { ReactComponent as Asegment } from "./a-segment.svg";
import { ReactComponent as Bsegment } from "./b-segment.svg";
import { ReactComponent as Csegment } from "./c-segment.svg";
import { ReactComponent as Dsegment } from "./d-segment.svg";
import { ReactComponent as Esegment } from "./e-segment.svg";
import { ReactComponent as Fsegment } from "./f-segment.svg";
import { ReactComponent as Sportscar } from "./sports-car.svg";
import { ReactComponent as Offroad } from "./4x4.svg";

export const carsIcons = {
  asegment: Asegment,
  bsegment: Bsegment,
  csegment: Csegment,
  dsegment: Dsegment,
  esegment: Esegment,
  fsegment: Fsegment,
  sportscar: Sportscar,
  offroad: Offroad,
}